module.exports = __webpack_public_path__ + "static/specialists-slideshow-02@2x-f2ec0a8af229a53915cb8c35146b1939.jpg";